
import {
  defineComponent,
  reactive,
  toRefs,
  onMounted,
  watch,
  ref,
  computed,
} from "vue";
import CusModal from "@component/CusModal/index.vue";
import { storeToRefs } from "pinia";
import { useGameListStore } from "@/store/gameList";
import { useloginStore } from "@/store/login";
import { useRouter, useRoute } from "vue-router";
import { useVipStore } from "@/store/vip";
import { useTurnVipStore } from "@/store/turnVip";
import { trackCustomizeEvent } from "@/js/stastic";

export default defineComponent({
  components: {
    CusModal,
  },
  name: "TurnVipModal",
  setup() {
    const gameListStore = useGameListStore();
    const loginStore = useloginStore();
    const router = useRouter();
    const route = useRoute();
    const vipStore = useVipStore();
    const turnVip = useTurnVipStore();
    const { isShowTurnVipModal } = storeToRefs(turnVip);

    const hideTurnVipModal = () => {
      turnVip.update_isShowTurnVipModal({
        isShow: false,
        vipType: 0,
        btnDesc: "",
        needTypeVip: 0,
      });
      console.log("hideTurnVipModal");
    };
    const btnDesc = computed(() => turnVip.btnDesc);

    // 购买成功后把弹窗关闭
    const turnVipPage = () => {
      if (route.path === "/GameLibrary" && !vipStore.vipType) {
        // 如果是在GameLibrary 并且不是vip身份 需要跳转vip
        router.push({ name: "VIP" });
        turnVip.update_isShowTurnVipModal({ isShow: false });
        return;
      }
      const tempObj: any = {
        isShow: true,
        kind: 2,
      };
      console.log("购买", turnVip);
      if (turnVip.needTypeVip === 7) {
        tempObj.goodsId = vipStore?.weeklyId;
      } else if ([1, 8, 9].includes(turnVip.needTypeVip)) {
        tempObj.goodsId = vipStore?.monthlyId;
      }
      gameListStore.update_isShowBuyGoodModal(tempObj);

      trackCustomizeEvent({
        event_id: "home_vip_exclusive_game_dialog_confirm",
        goodsId: tempObj.goodsId,
      });

      hideTurnVipModal();
    };

    // onMounted(()=>{
    //   trackCustomizeEvent({
    //     event_id: "home_vip_free_week_item_click",
    //     isVip: !!vipStore.vipType,
    //     vipType: vipStore.vipType,
    //     cloudGameId: item.gameId,
    //   });
    // })

    return {
      hideTurnVipModal,
      isShowTurnVipModal,
      turnVipPage,
      btnDesc,
    };
  },
});
